/**
 * @generated SignedSource<<c366cb7472f9814989a9951bbc19d00c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoStoresListItemResponseImage_todoImageResponse$data = {
  readonly __typename: "TodoResponseImage";
  readonly images: ReadonlyArray<{
    readonly id: string;
    readonly sizes: ReadonlyArray<{
      readonly height: number;
      readonly width: number;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"AHImageStackComponent_Images" | "Image_image">;
  }>;
  readonly " $fragmentType": "WorkspaceTodoStoresListItemResponseImage_todoImageResponse";
};
export type WorkspaceTodoStoresListItemResponseImage_todoImageResponse$key = {
  readonly " $data"?: WorkspaceTodoStoresListItemResponseImage_todoImageResponse$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoStoresListItemResponseImage_todoImageResponse">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoStoresListItemResponseImage_todoImageResponse",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Image_image"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AHImageStackComponent_Images"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "TodoResponseImage",
  "abstractKey": null
};

(node as any).hash = "c5044d7088bab03966a604e75c978855";

export default node;
